import React, { useEffect, useMemo } from 'react';
import Slide from '@material-ui/core/Slide';
// @ts-ignore
import { useRecoilState, useRecoilValue } from 'recoil';
import { snackbarIdState, snackbarOpenState, snackbarPropsState, } from './recoil';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import useTheme from '@material-ui/core/styles/useTheme';
import clsx from 'clsx';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import WarningIcon from '@material-ui/icons/ErrorOutlineOutlined';
import ErrorIcon from '@material-ui/icons/HighlightOffOutlined';
import SuccessIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import SettingsIcon from '@material-ui/icons/Settings';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Snackbar from '@dev-togetherprice/components.snackbar';
import LogoIcon from '@dev-togetherprice/icons.logo';
import BellIcon from '@dev-togetherprice/icons.bell';
import useSnackbar from './useSnackbar';
const useStyles = makeStyles((theme) => ({
    root: {
        [theme.breakpoints.up('md')]: {
            width: '100%',
            maxWidth: 325,
        },
    },
    contentRoot: {
        borderWidth: 2,
        borderStyle: 'solid',
        backgroundColor: 'transparent',
        padding: 0,
        width: '100%',
        borderRadius: 10,
    },
    contentMessage: {
        width: '100%',
        backgroundColor: 'white',
        borderRadius: 10,
        overflow: 'hidden',
        padding: 0,
    },
    message: {
        width: '100%',
        padding: theme.spacing(3.5, 4),
        alignItems: 'flex-start',
    },
    content: {
        paddingLeft: theme.spacing(3),
        overflow: 'hidden',
    },
    text: {
        lineHeight: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    title: {
        fontSize: 16,
        whiteSpace: 'nowrap',
        paddingBottom: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            fontSize: 14,
        },
    },
    body: {
        fontSize: 14,
        display: '-webkit-box',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
        [theme.breakpoints.down('sm')]: {
            fontSize: 12,
        },
    },
    actions: {
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: '#F9F9FC',
        color: '#38378B',
    },
    action: {
        borderRightWidth: 1,
        borderRightStyle: 'solid',
        padding: theme.spacing(0.5, 1),
        borderRightColor: theme.palette.grey[200],
        '&:last-child': {
            borderRightWidth: 0,
        },
    },
    itemIcon: {
        minWidth: 'unset',
        paddingRight: theme.spacing(2),
        fontSize: 24,
    },
    itemText: {
        textAlign: 'center',
        '& span': {
            fontSize: 14,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: 12,
            '& span': {
                fontSize: 12,
            },
        },
    },
    gradient: {
        position: 'relative',
        border: 'none',
        '&::before': {
            position: 'absolute',
            content: '""',
            zIndex: -1,
            borderRadius: 12,
            top: -2,
            left: -2,
            width: 'calc(100% + 4px)',
            height: 'calc(100% + 4px)',
            pointerEvents: 'none',
            background: 'linear-gradient(180deg, #FA5D75 0%, rgba(210, 95, 157, 0.93) 28.65%, rgba(120, 100, 246, 0.92) 100%)',
        },
    },
}));
// TODO move all stylings to snackbar component so snackbar provider will just handle states
const SnackbarProvider = ({ autoHideDuration = 15000, }) => {
    const classes = useStyles();
    const { closeSnackbar } = useSnackbar();
    const [open, setOpen] = useRecoilState(snackbarOpenState);
    const itemID = useRecoilValue(snackbarIdState);
    const snackbarProps = useRecoilValue(snackbarPropsState);
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const color = useMemo(() => {
        if (snackbarProps === null || snackbarProps === void 0 ? void 0 : snackbarProps.color)
            return snackbarProps === null || snackbarProps === void 0 ? void 0 : snackbarProps.color;
        switch (snackbarProps === null || snackbarProps === void 0 ? void 0 : snackbarProps.variant) {
            case 'info':
                return theme.palette.grey[800];
            case 'warning':
                return theme.palette.warning.main;
            case 'error':
                return theme.palette.error.main;
            case 'success':
                return theme.palette.success.main;
            case 'default':
            default:
                return '#89364D'; //'linear-gradient(180deg, rgba(252, 92, 114, 0.65) 0%, rgba(227, 94, 144, 0.533) 29.17%, rgba(101, 100, 253, 0.572) 100%);';
        }
    }, [snackbarProps, theme]);
    const extraClasses = useMemo(() => {
        if (snackbarProps === null || snackbarProps === void 0 ? void 0 : snackbarProps.color)
            return '';
        if (!(snackbarProps === null || snackbarProps === void 0 ? void 0 : snackbarProps.variant) || (snackbarProps === null || snackbarProps === void 0 ? void 0 : snackbarProps.variant) === 'default')
            return classes.gradient;
        return '';
    }, [snackbarProps, classes]);
    const Icon = useMemo(() => {
        if ((snackbarProps === null || snackbarProps === void 0 ? void 0 : snackbarProps.icon) && typeof (snackbarProps === null || snackbarProps === void 0 ? void 0 : snackbarProps.icon) !== 'string')
            return snackbarProps.icon;
        // 'bell' | 'settings'
        if (snackbarProps === null || snackbarProps === void 0 ? void 0 : snackbarProps.icon) {
            switch (snackbarProps === null || snackbarProps === void 0 ? void 0 : snackbarProps.icon) {
                case 'info':
                    return InfoIcon;
                case 'warning':
                    return WarningIcon;
                case 'error':
                    return ErrorIcon;
                case 'success':
                    return SuccessIcon;
                case 'logo':
                    return LogoIcon;
                case 'bell':
                    return BellIcon;
                case 'settings':
                    return SettingsIcon;
            }
        }
        switch (snackbarProps === null || snackbarProps === void 0 ? void 0 : snackbarProps.variant) {
            case 'info':
                return InfoIcon;
            case 'warning':
                return WarningIcon;
            case 'error':
                return ErrorIcon;
            case 'success':
                return SuccessIcon;
            case 'default':
            default:
                return LogoIcon;
        }
    }, [snackbarProps, theme]);
    const message = useMemo(() => {
        return (React.createElement(Grid, { container: true, direction: 'column' },
            React.createElement(ListItem, Object.assign({ onClick: snackbarProps === null || snackbarProps === void 0 ? void 0 : snackbarProps.onClick, className: classes.message, component: Grid, container: true, direction: 'row', wrap: 'wrap' }, ((snackbarProps === null || snackbarProps === void 0 ? void 0 : snackbarProps.onClick) && { button: true }), { disableGutters: true }),
                React.createElement(Grid, { item: true },
                    React.createElement(Icon, { fontSize: 'medium' })),
                React.createElement(Grid, { className: classes.content, item: true, xs: true },
                    (snackbarProps === null || snackbarProps === void 0 ? void 0 : snackbarProps.title) && (React.createElement(Typography, { className: clsx(classes.title, classes.text), variant: 'subtitle2' }, snackbarProps === null || snackbarProps === void 0 ? void 0 : snackbarProps.title)),
                    React.createElement(Typography, { className: clsx(classes.body, classes.text), variant: 'body1' }, snackbarProps === null || snackbarProps === void 0 ? void 0 : snackbarProps.message))),
            (snackbarProps === null || snackbarProps === void 0 ? void 0 : snackbarProps.actions) && snackbarProps.actions.length > 0 && (React.createElement(List, { className: classes.actions, disablePadding: true }, snackbarProps === null || snackbarProps === void 0 ? void 0 : snackbarProps.actions.map((action) => (React.createElement(ListItem, { onClick: action.onClick, className: classes.action, alignItems: 'center', button: true },
                action.icon && (React.createElement(ListItemIcon, { className: classes.itemIcon }, action.icon)),
                React.createElement(ListItemText, { classes: {}, className: classes.itemText }, action.label))))))));
    }, [snackbarProps, Icon, color, classes]);
    // if item id is changed then it means snackbar is changed and start timer again
    useEffect(() => {
        const timer = setTimeout(() => {
            if (open) {
                closeSnackbar();
            }
        }, autoHideDuration);
        return () => {
            clearTimeout(timer);
        };
    }, [itemID, autoHideDuration]);
    return (React.createElement(Snackbar, { open: open, itemID: itemID, onClose: () => setOpen(false), TransitionComponent: Slide, autoHideDuration: null, 
        //@ts-ignore
        TransitionProps: { direction: isDesktop ? 'left' : 'bottom' }, message: message, title: snackbarProps === null || snackbarProps === void 0 ? void 0 : snackbarProps.title, classes: { root: classes.root }, ContentProps: {
            classes: {
                root: clsx(extraClasses, classes.contentRoot),
                message: classes.contentMessage,
            },
            style: {
                borderColor: color,
                color: color,
            },
        }, variant: 'success' }));
};
export default SnackbarProvider;
